import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { RefWindowService } from './ref-window.service';
import { AppSettings } from '../app.settings';
import { AuthenticationService } from '../components/auth/auth.service';

@Injectable()
export class AuthTypeGuardService implements CanActivate {

	constructor(
		private router: Router,
		private authService: AuthenticationService,
		private windowRef: RefWindowService
	) { }
	canActivate() {
		const authType = this.authService.authTypeOutput ? this.authService.authTypeOutput.cusAuth : null;
		if (!authType) {
			this.router.navigate(['auth-direct']);
		} else {
			switch (authType.type) {
				case 'LB':
				case 'AD':
					return true
				case 'Esri':
					const secret = authType.secret;
					const url = secret.url + '?client_id=' + secret.clientId + '&response_type=token&redirect_uri=' + AppSettings.appRoot;
					this.windowRef.nativeWindow.open(url, '_self');
					return false;
			}
		}
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/auth-type-guard.service.ts